/**
 * File wprest.js.
 *
 * WP Ajax helper.
 *
 * Call the function with a .then to get the result.
 *
 * @package wildrivers
 */

export function WPAjax( hook, data, debug = false ) {

    return new Promise(function( resolve, reject ) {
        if ( debug ) {
            console.log( hook, data );
        }
        
        const requestData = {
            action: hook,
            ...data
        };
    
        const xhttp = new XMLHttpRequest();
    
        xhttp.onreadystatechange = function() {
            if ( this.readyState == 4 && this.status == 200 ) {
                if ( debug ) {
                    console.log( this, this.responseText );
                }
                resolve(this.responseText);
            }
        };
        xhttp.onerror = reject;
        xhttp.open( 'POST', location.origin  + '/wp-admin/admin-ajax.php', true);
        xhttp.setRequestHeader( 'Content-type', 'application/x-www-form-urlencoded; charset=UTF-8');
        xhttp.send( objectToQueryString( requestData ) );
    });
}

function objectToQueryString( object ) {
    return Object.keys( object )
        .filter( ( key ) => object[ key ] !== undefined && object[ key ] !== null )
        .map( ( key ) => encodeURIComponent( key ) + '=' + encodeURIComponent( String( object[ key ] ) ) )
        .join( '&' );
}
